module.exports = __webpack_public_path__ + "static/media/tp_icon.ac137e8b.ico";